exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eds-pagination {\n  margin-left: -8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js??ref--2-3!./src/pages/SearchPage.scss
// module id = 2508
// module chunks = 0